import React from 'react';

/**
 * Render a minimal, safe subset of markdown used by assistant responses.
 * We only support bold markers for now and let React escape all plain text.
 */
export function renderMessageText(text: string): React.ReactNode {
  const boldPattern = /\*\*([\s\S]+?)\*\*/g;
  const parts: React.ReactNode[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null = null;

  while ((match = boldPattern.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }

    parts.push(
      <strong key={`bold-${match.index}`}>
        {match[1]}
      </strong>
    );

    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return parts.length > 0 ? parts : text;
}
